import { render } from "./Notification3.vue?vue&type=template&id=39f211b5"
import script from "./Notification3.vue?vue&type=script&lang=js"
export * from "./Notification3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__